import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { updateClient } from "../../services/dashboard-api";

// import { getUser, getIdToken } from "../../utils/storage";

// import { uploadLogo } from "../../services/storage";

const OrganizationInfo = (props) => {
  const { client, setToast } = props;

  const [logoUrl, setLogoURL] = useState();
  const [logoFile, setLogoFile] = useState(null);
  const [organizationName, setOrganizationName] = useState(
    client.organizationName || ""
  );
  const [officeAddress, setOfficeAddress] = useState(
    client.officeAddress || ""
  );
  const [logoPreviewURL, setLogoPreviewURL] = useState(null);
  const [uploadedLogoURL, setUploadedLogoURL] = useState(null);

  // inside your component
  const toastTimer = useRef(null);

  const currentLogoURL = logoPreviewURL || uploadedLogoURL || client?.logoURL;

  const showToast = (toast, duration = 10000) => {
    clearTimeout(toastTimer.current);
    setToast({ show: true, ...toast });

    if (duration) {
      toastTimer.current = setTimeout(() => {
        setToast((prev) => ({ ...prev, show: false }));
      }, duration);
    }
  };

  // clear the timer if the component unmounts
  useEffect(() => () => clearTimeout(toastTimer.current), []);
  // const user = getUser(),
  //   idToken = getIdToken();

  const handleChangeLogoFile = (e) => {
    const file = e.target.files?.[0];

    if (!file) {
      return;
    }

    const supportedTypes = ["image/jpeg", "image/png", "image/webp"];

    if (!supportedTypes.includes(file.type)) {
      showToast({
        type: "warning",
        message: "Please select a JPG, PNG, or WebP image.",
      });
      return;
    }

    if (file.size > 240 * 1024) {
      showToast({
        type: "warning",
        message: "Logo must not exceed 240KB.",
      });
      return;
    }

    setLogoFile(file);

    // Temporary preview only.
    const previewURL = URL.createObjectURL(file);
    setLogoPreviewURL(previewURL);
  };

  const uploadLogoImage = async () => {
    if (!logoFile) {
      throw new Error("Please select a logo");
    }

    const idToken = localStorage.getItem("idToken");

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/versus/uploadurl`,
      {
        mimeType: logoFile.type,
        context: "clients",
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    await axios.put(data.uploadUrl, logoFile, {
      headers: {
        "Content-Type": logoFile.type,
      },
    });

    return data.finalUrl;
  };

  // const handleSaveLogo = (e) => {
  //   setToast({
  //     show: true,
  //     type: "processing",
  //     message: "Updating client logo...",
  //   });

  //   uploadLogo(client.brandName, client.clientRef, logoFile)
  //     .then((snapshot) => {
  //       snapshot.ref
  //         .getDownloadURL()
  //         .then((url) => {
  //           console.log("successfully uploaded logo", url);
  //           setLogoURL(url);
  //           // Add url to client data
  //           // const clientData = { ...client, logoURL: url };
  //           axios
  //             .post(
  //               `${process.env.REACT_APP_API_BASE_URL}/versus_v2_edit_client`,
  //               {
  //                 idToken,
  //                 uid: user.uid,
  //                 email: user.email,
  //                 clientData: { logoURL: url },
  //               },
  //               { headers: { "content-type": "application/json" } }
  //             )
  //             .then((result) => {
  //               if (result.status === 200) {
  //                 console.log("Updated client logo");
  //                 setToast({
  //                   show: true,
  //                   type: "success",
  //                   message: "Updated client logo",
  //                 });
  //               }
  //             })
  //             .catch((error) => {
  //               console.log("Error updating client logo", error);
  //               setToast({
  //                 show: true,
  //                 type: "warning",
  //                 message:
  //                   error.response.data.message ||
  //                   "Had trouble updating client logo. Please try again",
  //               });
  //             });
  //         })
  //         .catch((error) => console.log("Error getting logo url", error));
  //     })
  //     .catch((error) => {
  //       console.log("Error uploading logo", error);
  //     });
  // };

  const handleSaveClient = async () => {
    try {
      showToast({
        type: "processing",
        message: "Updating organization information...",
      });

      let logoUrl = client?.logoURL;

      if (logoFile) {
        showToast({
          type: "processing",
          message: "Uploading organization logo...",
        });

        logoUrl = await uploadLogoImage();

        setUploadedLogoURL(logoUrl);
      }

      console.log("Logo URL being saved:", logoUrl);

      await updateClient({
        email: client?.email,
        clientRef: client.clientRef,
        organizationName,
        officeAddress,
        logoUrl,
      });

      showToast({
        type: "success",
        message: "Successfully updated organization information",
      });
    } catch (error) {
      console.error("Error updating organization information", error);

      showToast({
        type: "warning",
        message:
          error.response?.data?.message ||
          error.message ||
          "Had trouble updating organization information. Please try again",
      });
    }
  };

  return (
    <div className="card-2">
      <div className="card-section">
        <h3 className="push-up">Organization info</h3>
        <div className="control row">
          <div
            className={`avatar ${
              currentLogoURL ? "with-picture" : "alpha"
            } large`}
            style={{
              backgroundImage: currentLogoURL
                ? `url("${currentLogoURL}")`
                : "none",
            }}
          />
          <div className="move-right vertical align-left">
            <div>Logo</div>
            <div className="meta">240kb maximum size</div>
            <label htmlFor="logo-input">
              <span
                className="button small subtle with-icon w-button"
                // style={{ cursor: "not-allowed" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-upload icon small nudge-left"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="17 8 12 3 7 8"></polyline>
                  <line x1="12" y1="3" x2="12" y2="15"></line>
                </svg>{" "}
                Upload logo
              </span>
            </label>
            <input
              type="file"
              id="logo-input"
              style={{ display: "none" }}
              onChange={handleChangeLogoFile}
            />
          </div>
        </div>
        <div className="form-block push-down fill w-form">
          <form>
            <div className="row">
              <div className="control move-left">
                <label htmlFor="organization-name">Organization name</label>
                <input
                  type="text"
                  id="organization-name"
                  className="input-2 w-input"
                  maxLength="256"
                  value={organizationName}
                  onChange={(e) => setOrganizationName(e.target.value)}
                />
              </div>
              <div className="control">
                <label htmlFor="organization-address">
                  Organization address
                </label>
                <input
                  type="text"
                  id="organization-address"
                  className="input-2 w-input"
                  maxLength="256"
                  value={officeAddress}
                  onChange={(e) => setOfficeAddress(e.target.value)}
                />
              </div>
            </div>
          </form>
          <span
            className="button small primary w-button"
            onClick={handleSaveClient}
          >
            Save changes
          </span>
        </div>
      </div>
    </div>
  );
};

export default OrganizationInfo;
